import React from "react";
import { Button } from "react-bootstrap";

const TableFilter = (props) => {

  const {filter ,setFilter } = props;

  return (
    <>
      <div className="TableFilters d-flex align-items-center justify-content-between gap-10 p-3 p-lg-4  flex-wrap">
        <div className="left d-flex align-items-center gap-10 flex-wrap">
          <h2 className="m-0 fw-bold heading">Posts Management</h2>
          <div className="searchForm position-relative icon-with-text">
            <input
              type="text"
              placeholder="Search by Name, email"
              className="form-control rounded-pill cstmShadow"
              value={filter.search}
              onChange={(e) =>setFilter({ search : e.target.value })}
            />
            <span className="position-absolute icn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M7.1875 13.125C10.4667 13.125 13.125 10.4667 13.125 7.1875C13.125 3.90831 10.4667 1.25 7.1875 1.25C3.90831 1.25 1.25 3.90831 1.25 7.1875C1.25 10.4667 3.90831 13.125 7.1875 13.125Z"
                  stroke="#9DA3BB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.75 13.75L12.5 12.5"
                  stroke="#9DA3BB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </div>
        <div className="right d-flex align-items-center justify-content-end gap-10 flex-wrap btnWrpper">
          <div className="px-2">
            {/* <Button className="d-flex w-100 cstmShadow align-items-center justify-content-center rounded-pill ">
              Filter
              <span className="ms-2 icn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 5.83333C14.1421 5.83333 17.5 5.08714 17.5 4.16667C17.5 3.24619 14.1421 2.5 10 2.5C5.85786 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 5.85786 5.83333 10 5.83333Z"
                    stroke="#9DA3BB"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 4.16663C2.5 6.02496 5.72583 9.72829 7.38 11.5041C7.9868 12.1473 8.32743 12.9965 8.33333 13.8808V18.3333L11.6667 16.6666V13.8808C11.6667 12.9966 12.0175 12.1516 12.62 11.5041C14.275 9.72829 17.5 6.02579 17.5 4.16663"
                    stroke="#9DA3BB"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>{" "}
            </Button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default TableFilter;
